import {
    getDefaultTrialCalendarFilter,
    ITrialCalendarFilter,
    ITrialCreationDraft,
    TTutorGender,
} from '../../../entities/trialLesson'

const GENDERS = new Set<TTutorGender>([
    'TUTOR_GENDER_MALE',
    'TUTOR_GENDER_FEMALE',
    'TUTOR_GENDER_ANY',
])

export const EMPTY_TRIAL_CREATION_DRAFT: ITrialCreationDraft = {
    tgAccountId: '',
    tagId: '',
    tutorGender: 'TUTOR_GENDER_UNSPECIFIED',
    durationSlots: 1,
}

export const getTrialCreationDraftFromSearchParams = (
    params: URLSearchParams,
): ITrialCreationDraft => {
    const tutorGender = params.get('trialCreationTutorGender') as TTutorGender

    return {
        tgAccountId: params.get('trialCreationTgAccountId') || '',
        tagId: params.get('trialCreationTagId') || '',
        tutorGender: GENDERS.has(tutorGender)
            ? tutorGender
            : 'TUTOR_GENDER_UNSPECIFIED',
        durationSlots: Math.min(
            48,
            Math.max(1, Number(params.get('trialCreationDurationSlots')) || 1),
        ),
    }
}

export const setTrialCreationDraftSearchParams = (
    params: URLSearchParams,
    draft: ITrialCreationDraft,
): URLSearchParams => {
    const next = new URLSearchParams(params)

    if(draft.tgAccountId) next.set('trialCreationTgAccountId', draft.tgAccountId)
    else next.delete('trialCreationTgAccountId')
    if(draft.tagId) next.set('trialCreationTagId', draft.tagId)
    else next.delete('trialCreationTagId')
    if(draft.tutorGender !== 'TUTOR_GENDER_UNSPECIFIED'){
        next.set('trialCreationTutorGender', draft.tutorGender)
    }
    else next.delete('trialCreationTutorGender')
    next.set('trialCreationDurationSlots', String(draft.durationSlots))

    return next
}

export const clearTrialCreationSearchParams = (params: URLSearchParams): URLSearchParams => {
    const next = new URLSearchParams(params)
    next.delete('createTrial')
    next.delete('trialCreationTgAccountId')
    next.delete('trialCreationTagId')
    next.delete('trialCreationTutorGender')
    next.delete('trialCreationDurationSlots')
    return next
}

export const isTrialCreationDraftComplete = (draft: ITrialCreationDraft): boolean => {
    return Boolean(draft.tgAccountId) && Boolean(draft.tagId) &&
        GENDERS.has(draft.tutorGender) && draft.durationSlots > 0
}

// The original calendar flow creates a trial directly after opening a day.
// It remains available only for the fully singular legacy filter.
export const isTrialCalendarCreationFilterComplete = (
    filter: ITrialCalendarFilter,
): boolean => {
    return filter.tgAccountIds.length === 1 &&
        filter.tagIds.length === 1 &&
        filter.userIds.length === 1 &&
        GENDERS.has(filter.tutorGender) &&
        filter.requiredDurationSlots > 0
}

export const trialCreationDraftToFilter = (
    draft: ITrialCreationDraft,
): ITrialCalendarFilter => ({
    ...getDefaultTrialCalendarFilter(),
    tgAccountIds: draft.tgAccountId ? [draft.tgAccountId] : [],
    tagIds: draft.tagId ? [draft.tagId] : [],
    userIds: [],
    tutorGender: draft.tutorGender,
    requiredDurationSlots: draft.durationSlots,
})
